import { toast } from 'react-toastify';
import { useWompiModel } from '../../../../modelos/WompiPagos/modeloWompiPagos';
import React, { useEffect, useState, useMemo } from 'react';
import { CreditCard } from 'lucide-react';

const WompiPagoWidget = ({ valor, referencia, onSuccess , titulo = "Pagar con Wompi" }) => {
    const [loading, setLoading] = useState(false);
    const {obtenerFirmaIntegridad} = useWompiModel();

    const manejarPago = async () => {
        try {
            setLoading(true);
            
            // 1. Wompi requiere el monto en centavos (ej: 1000 pesos = 100000)
            const montoEnCentavos = Math.round(parseFloat(valor) * 100);
            
            // 2. Obtener firma desde tu backend (Seguridad Obligatoria)
            const firma = await obtenerFirmaIntegridad(referencia, montoEnCentavos);
            console.log("la firma es",firma);

            if (!firma) throw new Error("No se pudo generar la firma de seguridad");

            const config = {
                currency: 'COP',
                amountInCents: Math.round(valor * 100), // Debe ser número entero
                reference: referencia, // Debe ser string
                publicKey: 'pub_test_Iy3hvENkmxAaHpRa9zpfIdTSYxRPevhW', // Ponla manual para probar
                signature: { integrity: firma },
                //redirectUrl: `${window.location.origin}/pago-confirmado`
            };

            // 3. Configurar el objeto global de Wompi
            console.log("Configuración enviada a Wompi:", config);
            const checkout = new window.WidgetCheckout(config);

            // 4. Abrir el modal
            checkout.open((result) => {
                const { transaction } = result;
                if (transaction.status === 'APPROVED') {
                    toast.success("Pago procesado exitosamente");
                    if (onSuccess) onSuccess(transaction); // Ejecuta handleRegistrarPago() de tu ModuloPagos
                } else {
                    toast.warn(`Estado: ${transaction.status}`);
                }
            });

        } catch (error) {
            console.error("Error Wompi:", error);
            toast.error("Error al conectar con la pasarela de pagos");
        } finally {
            setLoading(false);
        }
    };

    return (
        <button
            type="button"
            onClick={manejarPago}
            disabled={loading || !valor || valor <= 0}
            className={`w-full flex items-center justify-center gap-2 px-4 py-3 rounded-md font-bold text-white transition-all 
                ${loading ? 'bg-gray-400' : 'bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700 shadow-md'}`}
        >
            <CreditCard size={20} />
            {loading ? 'Cargando Pasarela...' : titulo}
        </button>
    );
}

export default WompiPagoWidget
